import Button from "components/atoms/Button";
import BuyNowButton from "components/atoms/BuyNowButton";
import Image from "components/atoms/Image";
import Link from "components/atoms/Link";
import Loading from "components/atoms/Loading";
import LoadingState from "components/atoms/LoadingState";
import Text from "components/atoms/Text";
import AboutSection from "components/molecules/CardSection";
import Carousel from "components/molecules/Carousel";
import CarouselItem from "components/molecules/Carousel/CarouselItem";
import CartBox from "components/molecules/CartBox";
import Player from "components/molecules/player";
import StringToHtml from "components/molecules/StringToHtml";
import Support from "components/molecules/Support";
import { Tab, TabList, TabPanel, Tabs } from "components/molecules/Tabs";
import { BASE_URL } from "constants/env";
import { PRODUCTS_FEATURE } from "constants/swiper";
import { useSelector } from "hooks/useApp";
import useWindowScroll from "hooks/useWindowScroll";
import useWindowScrollSimple from "hooks/useWindowScrollSimple";
import useWindowSize from "hooks/useWindowSize";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";
import LazyLoad from "react-lazyload";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { updateCartProducts } from "redux/actions/products/cart";
import { SwiperSlide } from "swiper/react";
import { joinClassnames, mapMultiClassnames } from "utils/map-modifier";
import Grid, { GridCol, GridRow } from "../Grid";
import "./index.scss";

interface ScrollTabProductDetailProps {
  animation?: boolean;
  projectHeading?: React.ReactNode;
  children?: React.ReactNode;
  modifiers?: "overlay"[];
  productInfoRef?: any;
  productTabRef?: any;
  detailProduct: any;
  quantity: number;
  onToggleInfoBuyingForm: () => void;
}

const ScrollTabProductDetail: React.FC<ScrollTabProductDetailProps> = ({
  animation,
  productInfoRef,
  productTabRef,
  detailProduct,
  quantity,
  onToggleInfoBuyingForm,
}) => {
  const {
    name,
    thumbnail,
    images_slider,
    is_use_detail_editor,
    detail_editor,
    detail,
    specs,
    catalogue_url,
    model,
    discount,
    price,
    product_type_id,
  } = detailProduct;
  const { width } = useWindowSize();
  const investRef: any = useRef();
  const tabRef: any = useRef();
  const useAnimmation = animation || false;
  const [fixedHeadingClass, setFixedHeadingClass] = useState("showheading");
  const [selected, setSelected] = useState(0);
  const { loading } = useSelector(state => state.products.cart);
  const [isBuyingClick, setIsBuyingClick] = useState(false);
  const { pageYOffset } = useWindowScroll(10);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleShowHeading = useCallback(() => {
    const condition = pageYOffset > productInfoRef.current.clientHeight + 128;
    setFixedHeadingClass(condition ? "hideheading" : "showheading");
  }, [pageYOffset, productInfoRef]);

  useEffect(() => {
    handleShowHeading();
  }, [handleShowHeading, pageYOffset]);

  const scrollToRef = useCallback(
    (index: number) => {
      setSelected(index);
      window.scrollTo(0, productInfoRef.current.clientHeight + 126);
    },
    [productInfoRef],
  );

  const isPassProductTypeCondition = useMemo(
    () =>
      product_type_id === 1 || product_type_id === 2 || product_type_id === 3,
    [product_type_id],
  );

  const updateCart = useCallback(() => {
    if (isPassProductTypeCondition) {
      dispatch(updateCartProducts(detailProduct, quantity));
      setIsBuyingClick(true);
    } else {
      onToggleInfoBuyingForm();
    }
  }, [
    detailProduct,
    dispatch,
    isPassProductTypeCondition,
    onToggleInfoBuyingForm,
    quantity,
  ]);

  useEffect(() => {
    if (!loading && isBuyingClick) {
      setIsBuyingClick(false);
      history.push("/gio-hang");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, isBuyingClick]);

  const firstRef = useRef(null);
  const [firstList, setFirstList] = useState([]);
  const [lastList, setLastList] = useState([]);
  const [showLastList, setShowLastList] = useState(false);

  // const [contentWidth, setContentWidth] = useState("100%");
  const [showContentEditor, setShowContentEditor] = useState(false);
  const [loadingShowContentEditor, setLoadingShowContentEditor] = useState(
    false,
  );

  const itemsProductDetail = useMemo(() => {
    return (
      detail &&
      Object.values(JSON.parse(detail)).sort(
        (a: any, b: any) => Number(a.display_order) - Number(a.display_order),
      )
    );
  }, [detail]);

  const limitSliceItem = useMemo(() => (width < 992 ? 1 : 3), [width]);

  useEffect(() => {
    if (itemsProductDetail && itemsProductDetail.length > 0) {
      setFirstList(itemsProductDetail.slice(0, limitSliceItem));
      setLastList(
        itemsProductDetail.slice(limitSliceItem, itemsProductDetail.length),
      );
    }
  }, [itemsProductDetail, limitSliceItem]);

  useEffect(() => {
    if (loadingShowContentEditor) {
      setTimeout(() => {
        setShowContentEditor(!showContentEditor);
      }, 250);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingShowContentEditor]);

  // let findElm: HTMLElement | null;
  // let contentElm: HTMLCollectionOf<Element> | null;
  // const setWidthViewMoreContent = () => {
  //   if (!findElm) {
  //     findElm = document.getElementById("cms-editor");
  //   }

  //   if (findElm) {
  //     if (!contentElm) {
  //       contentElm = findElm.getElementsByClassName("responsive-classes");
  //     }
  //     if (contentElm.length) {
  //       setContentWidth(`${contentElm[0].clientWidth}px`);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   setWidthViewMoreContent();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const priceLabel = useMemo(
    () =>
      discount &&
        price &&
        Object.keys(discount).length > 0 &&
        discount.discount_value > 0
        ? discount.discount_type === 1
          ? window.formatMoney(
            Math.round((price * (1 - discount.discount_value / 100)) / 1000) *
            1000,
          )
          : price - discount.discount_value
        : window.formatMoney(price),
    [discount, price],
  );

  const {
    outstock: { isOutStock },
  } = useSelector(state => state.view);

  const [fixedBuynowMobileClass, setFixedBuynowMobileClass] = useState("");
  const inlineBuynowMobileEle = document.getElementsByClassName(
    "buynow-inline-btn",
  )[0];

  useWindowScrollSimple(() => {
    if (inlineBuynowMobileEle) {
      const rect = (inlineBuynowMobileEle as HTMLElement).getBoundingClientRect();
      const bottom = rect["bottom"];
      setFixedBuynowMobileClass(bottom < 0 ? "hideheading" : "showheading");
    }
  }, 0);

  const renderCarouselImagesSlider = useMemo(() => {
    return (
      images_slider &&
      Object.values(images_slider)
        .sort(
          (a: any, b: any) => Number(a.display_order) - Number(b.display_order),
        )
        .filter((item: any) => item && (item.thumb || item.youtube_embedded))
        .map((item: any, i: number) => {
          return (
            <SwiperSlide key={i}>
              <CarouselItem>
                {item.thumb !== null ? (
                  <Image
                    src={`${BASE_URL}${item.thumb}`}
                    alt={`Image Slider ${i}`}
                  />
                ) : item.youtube_embedded ? (
                  <Player
                    src={item.youtube_embedded}
                    ratio={0.5625} // 16:9
                  />
                ) : null}
              </CarouselItem>
            </SwiperSlide>
          );
        })
    );
  }, [images_slider]);
  const infoDesktop = useMemo(() => {
    return (
      <div className="o-scroll-tab-info-product desktop">
        <div className="groupbox image">
          <CartBox.Image>
            <Image alt={name} src={`${BASE_URL}${thumbnail}`} />
          </CartBox.Image>
        </div>

        <div className="groupbox info">
          <CartBox.Info>
            <CartBox.Name>{model}</CartBox.Name>
            {price && (
              <CartBox.Price>
                <CartBox.Label>{priceLabel}</CartBox.Label>
              </CartBox.Price>
            )}
          </CartBox.Info>
        </div>

        {isPassProductTypeCondition ? (
          <div className="groupbox buynow">
            {!isOutStock ? (
              <BuyNowButton
                className="buynow-button"
                type="buynow"
                handleClick={updateCart}
              />
            ) : (
              <BuyNowButton
                type="outstock"
                className="in-fixed-scroll-tab-desktop"
              />
            )}
          </div>
        ) : (
          <div className="groupbox buynow">
            <Button
              variant="primary"
              className="buynow-button"
              modifiers={["rounded"]}
              iconName="cart-white"
              onClick={updateCart}
            >
              TƯ VẤN
            </Button>
          </div>
        )}
      </div>
    );
  }, [
    isOutStock,
    isPassProductTypeCondition,
    model,
    name,
    price,
    priceLabel,
    thumbnail,
    updateCart,
  ]);
  const tabFunctions = useMemo(() => {
    return (
      <TabList className="tab-functions">
        <Tab
          iconName={selected === 0 ? "function-selected" : "function-white"}
          onClick={() => scrollToRef(0)}
        >
          Tính năng
        </Tab>
        <Tab
          iconName={selected === 1 ? "setting-selected" : "setting-white"}
          onClick={() => scrollToRef(1)}
        >
          Thông số kỹ thuật
        </Tab>
        <Tab
          iconName={selected === 2 ? "phone-selected" : "phone-white"}
          onClick={() => scrollToRef(2)}
        >
          Hỗ trợ
        </Tab>
      </TabList>
    );
  }, [scrollToRef, selected]);
  const tabPanel1 = useMemo(() => {
    return (
      <TabPanel>
        {images_slider !== null && (
          <div className="product-detail-slider-img">
            <Carousel pagination breakpoints={PRODUCTS_FEATURE()} autoHeight>
              {images_slider && renderCarouselImagesSlider}
            </Carousel>
          </div>
        )}
        {is_use_detail_editor === 1 ? (
          <>
            {detail_editor ? (
              <div
                id="cms-editor"
                className={joinClassnames(
                  "cms-editor",
                  showContentEditor && "extend",
                )}
              >
                <StringToHtml content={detail_editor} />
                {!showContentEditor && (
                  <div className="view-more-product-detail">
                    {loadingShowContentEditor ? (
                      <Loading />
                    ) : (
                      <Button
                        variant="outline"
                        size="small"
                        modifiers={[
                          "rounded",
                          "light-blue",
                          "small-radius",
                          "full-width-mobile",
                        ]}
                        onClick={() => {
                          setLoadingShowContentEditor(true);
                        }}
                      >
                        MỞ RỘNG
                      </Button>
                    )}
                  </div>
                )}
              </div>
            ) : null}
          </>
        ) : detail ? (
          Object.values(JSON.parse(detail)).length > 0 ? (
            <div
              className={joinClassnames(
                "product-detail-cardsection-desc",
                showLastList && "show-all",
              )}
            >
              <div ref={firstRef}>
                {firstList.length &&
                  firstList.map((section: any, i: number) => {
                    return (
                      <AboutSection
                        title={section.title}
                        description={section.content}
                        imgSrc={section.image}
                        key={i}
                        modifiers={(() => {
                          switch (section.layout) {
                            case "2":
                              return "imageRight";
                            case "3":
                              return "imageTop";
                            case "4":
                              return "imageBottom";
                            default:
                              return "imageLeft";
                          }
                        })()}
                      />
                    );
                  })}
              </div>

              {lastList.length ? (
                <>
                  <div
                    className={joinClassnames(
                      "last-list",
                      showLastList && "showLastList",
                    )}
                  >
                    {lastList.length
                      ? lastList.map((section: any, i: number) => (
                        <AboutSection
                          title={section.title}
                          description={section.content}
                          imgSrc={section.image}
                          key={i}
                          modifiers={(() => {
                            switch (section.layout) {
                              case "2":
                                return "imageRight";
                              case "3":
                                return "imageTop";
                              case "4":
                                return "imageBottom";
                              default:
                                return "imageLeft";
                            }
                          })()}
                        />
                      ))
                      : null}
                  </div>

                  <div className="view-more-product-detail">
                    <Button
                      variant="outline"
                      modifiers={[
                        "rounded",
                        "small-radius",
                        "w-min-170",
                        "full-width-mobile",
                      ]}
                      onClick={() => {
                        setShowLastList(!showLastList);
                      }}
                    >
                      {!showLastList ? "XEM THÊM" : "ĐÓNG LẠI"}
                    </Button>
                  </div>
                </>
              ) : null}
            </div>
          ) : (
            <Text weight="bold">Không có thông tin</Text>
          )
        ) : (
          <Text weight="bold">Không có thông tin</Text>
        )}
      </TabPanel>
    );
  }, [
    detail,
    detail_editor,
    firstList,
    images_slider,
    is_use_detail_editor,
    lastList,
    loadingShowContentEditor,
    renderCarouselImagesSlider,
    showContentEditor,
    showLastList,
  ]);
  const tabPanel2 = useMemo(() => {
    return (
      <TabPanel>
        <div className="custom-table">
          <div
            dangerouslySetInnerHTML={{
              __html: specs || "",
            }}
          />
        </div>
      </TabPanel>
    );
  }, [specs]);
  const tabPanel3 = useMemo(() => {
    return (
      <TabPanel>
        <div id="TypeOffInvest" ref={investRef} />
        <Grid className="grid-support-items">
          <GridRow>
            {catalogue_url ? (
              <GridCol colSm={6} colMd={4}>
                <Link
                  isLinkRouter={false}
                  href={
                    catalogue_url.length > 0 && `${BASE_URL}${catalogue_url}`
                  }
                >
                  <Support
                    iconName="support-setting"
                    title="Tải Catalogue Sản Phẩm"
                  />
                </Link>
              </GridCol>
            ) : null}
            <GridCol colSm={6} colMd={4}>
              <Link href="/faq">
                <Support
                  iconName="support-question"
                  title="Câu Hỏi Thường Gặp"
                />
              </Link>
            </GridCol>
            <GridCol colSm={6} colMd={4}>
              <Link href="/lien-he">
                <Support iconName="support-contact" title="Liên Hệ Tư Vấn" />
              </Link>
            </GridCol>
          </GridRow>
        </Grid>
      </TabPanel>
    );
  }, [catalogue_url]);

  return (
    <>
      <Grid>
        <GridRow>
          <GridCol>
            <Tabs modifiers={["big", "primary"]}>
              <LazyLoad once>
                <div
                  className={mapMultiClassnames(
                    "o-scroll-tab",
                    useAnimmation && "anim",
                    fixedHeadingClass,
                  )}
                  ref={tabRef}
                >
                  {infoDesktop}
                  {tabFunctions}
                </div>
                {tabPanel1}
                {tabPanel2}
                {tabPanel3}
              </LazyLoad>
            </Tabs>
          </GridCol>
        </GridRow>
      </Grid>
      {isBuyingClick && <LoadingState />}

      {/* MOBILE */}
      {/* bottom fixed content */}
      <div
        className={joinClassnames(
          "o-scroll-tab-info-product",
          "mobile",
          fixedBuynowMobileClass,
        )}
      >
        <div className="groupbox info">
          <CartBox.Info>
            <CartBox.Name>{model}</CartBox.Name>
            {price && (
              <CartBox.Price>
                <CartBox.Label>{priceLabel}</CartBox.Label>
              </CartBox.Price>
            )}
          </CartBox.Info>
        </div>

        {isPassProductTypeCondition ? (
          <div className="groupbox buynow mobile">
            {!isOutStock ? (
              <BuyNowButton
                className="buynow-button"
                modifier="white"
                type="buynow"
                hideIcon
                handleClick={updateCart}
              />
            ) : (
              <BuyNowButton
                type="outstock"
                hideIcon
                className="in-fixed-scroll-tab-mobile buynow-button small-font"
              />
            )}
          </div>
        ) : (
          <div className="groupbox buynow mobile">
            <Button
              className="buynow-button"
              variant="light"
              modifiers={["rounded", "white"]}
              onClick={updateCart}
            >
              TƯ VẤN
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(ScrollTabProductDetail);
